export default window => /bot|google|phantom|crawler|spider|robot|crawling|^Mozilla\/4\.0$/i.test(window.navigator.userAgent)


// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/isBot.js